import React, {Component} from "react";
import {connect} from "react-redux";
import {List, fromJS, Map} from "immutable";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import FilterPanel from "../../components/panels/FilterPanel";
import PurchaseOrdersList from "./views/PurchaseOrdersList";
import PurchaseOrderDetails from "./views/PurchaseOrderDetails";
import {PurchaseOrderStatusPanel, PurchaseOrderInfoPanel, PurchaseOrderActionsPanel} from "./panels/PurchaseOrderPanels";
import {requestCreatePurchaseOrder} from "../../actions/PurchaseOrderApiActions";
import {getAllWarehouses, addAllWarehousesOption} from "../../lib/Warehouses";

const statusFilterKey = "status";
const destinationFilterKey = "destination_warehouse_id";
const statusFilterOptions = fromJS([
  {id: "", label: "All Purchase Orders"},
  {id: "draft", label: "Draft"},
  {id: "ordered", label: "Ordered"},
  {id: "received", label: "Received"},
  {id: "cancelled", label: "Cancelled"},
]);

// Pages: "purchase-orders" (list) and "purchase-order" (one, by :id).
class PurchaseOrdersPage extends Component {

  render() {
    const page = this.props.route.page;
    const query = Map(this.props.router.location.query);

    return (
      <div className="PurchaseOrdersPage SecurePage">
        <AppSidebar />
        <PageHeader
          title={page === "purchase-order" ? `Purchase Orders / ${this.props.params.id}` : "Purchase Orders"}
          backButton={page === "purchase-order"}
          onBack={() => this.props.router.push("/purchase-orders")} />
        <div className="PageContainer">
          {page === "purchase-order"
            ? <PurchaseOrderDetails purchaseOrderId={this.props.params.id} />
            : <PurchaseOrdersList
                onSelectionChange={(id) => this.props.router.push(`/purchase-orders/${id}`)}
                statusFilter={query.get(statusFilterKey, "")}
                destinationFilter={query.get(destinationFilterKey, "")} />}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {page === "purchase-orders" && List([
            <FilterPanel key="status" title="Status Filter" expanded={true} options={statusFilterOptions}
              onClick={(item) => this.setQuery(statusFilterKey, item.get("id"))} filter={query.get(statusFilterKey, "")} />,
            <FilterPanel key="destination" title="Deliver To" expanded={true} options={addAllWarehousesOption(getAllWarehouses())}
              onClick={(item) => this.setQuery(destinationFilterKey, item.get("id"))} filter={query.get(destinationFilterKey, "")} />,
          ])}
          {page === "purchase-order" && [
            <PurchaseOrderStatusPanel key="status" purchaseOrderId={this.props.params.id} />,
            <PurchaseOrderInfoPanel key="info" purchaseOrderId={this.props.params.id} />,
            <PurchaseOrderActionsPanel key="actions" purchaseOrderId={this.props.params.id} />,
          ]}
          {page === "purchase-orders" &&
            <PanelGroupController title="Actions">
              <ActionButton label="Create Purchase Order" onClick={() => this.props.requestCreatePurchaseOrder()} />
            </PanelGroupController>}
        </div>
      </div>
    );
  }

  setQuery(key, value) {
    const query = Map(this.props.router.location.query);
    this.props.router.push({
      pathname: "/purchase-orders",
      query: (value === "" ? query.delete(key) : query.set(key, value)).toJS()
    });
  }
}

export default connect(null, {requestCreatePurchaseOrder})(PurchaseOrdersPage);
